<svelte:options runes={true} />

<script lang="ts">
  import type { CommandManager, ToolManager } from '@commands';
  import type { Doc } from '@doc';
  import { Orientation, Size, size } from '@geom';
  import type { UndoManager } from '@reactive';
  import ClassPicker from './ClassPicker.svelte';
  import ClassRecents from './ClassRecents.svelte';
  import DocLocalePicker from './DocLocalePicker.svelte';
  import HorizontalDivider from './HorizontalDivider.svelte';
  import LayoutPicker from './LayoutPicker.svelte';
  import Toolbox from './Toolbox.svelte';
  import type { ToolboxLayoutConfig } from './ToolboxLayoutConfig';
  import UndoRedoButtons from './UndoRedoButtons.svelte';

  let {
    commandManager,
    undoManager,
    toolManager,
    doc = $bindable(),
    selectedUnitClass = $bindable(),
    toolboxLayout = $bindable({ width: 2 }),
    classPickerFlyout = $bindable(Orientation.HORIZONTAL)
  }: {
    commandManager: CommandManager;
    undoManager: UndoManager;
    toolManager: ToolManager;
    doc: Doc;
    selectedUnitClass: string | undefined;
    toolboxLayout?: ToolboxLayoutConfig;
    classPickerFlyout?: Orientation;
  } = $props();

  // Shared preview size for class previews
  let classPickerPreviewSize = $state<Size>(size(80, 50));
  let classRecentsPreviewSize = $state<Size>(size(40, 25));
  // Grid for ClassRecents (columns x rows) default 2x3
  let classRecentsGrid = $state<Size>(size(2, 3));
</script>

<style>
</style>

<div
  id="LeftBar"
  style="width: 12rem; padding: 10px; display: flex; flex-direction: column; gap: 10px;"
>
  <UndoRedoButtons {commandManager} {undoManager} />
  <HorizontalDivider />
  <Toolbox {commandManager} {toolManager} bind:layoutOrientation={toolboxLayout}
  ></Toolbox>
  <HorizontalDivider />
  <ClassPicker
    {commandManager}
    {doc}
    previewSize={classPickerPreviewSize}
    bind:selectedUnitClass
    bind:flyoutOrientation={classPickerFlyout}
  ></ClassPicker>
  <ClassRecents
    {commandManager}
    {doc}
    previewSize={classRecentsPreviewSize}
    bind:selectedUnitClass
    bind:gridSize={classRecentsGrid}
  ></ClassRecents>
  <HorizontalDivider />
  <LayoutPicker {commandManager} bind:doc></LayoutPicker>
  <DocLocalePicker {commandManager} keyManager={toolManager.keyManager} bind:doc
  ></DocLocalePicker>
</div>
